(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cyber-stark-landing"]) return;
  try {
    
(() => {
  const CYBER_PATH = '/pages/cyber-stark';
  const PIXEL_ID = '1015430279736548';
  const SUCCESS_TEXT = 'REGISTRO COMPLETADO';

  if (window.location.pathname.replace(/\/$/, '') !== CYBER_PATH) return;
  if (window.__cyberStarkLeadWatcher) return;
  window.__cyberStarkLeadWatcher = true;

  let leadFired = false;
  const watchedRoots = new WeakSet();

  const normalizeText = (value) =>
    (value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toUpperCase();

  const isVisible = (element) => {
    if (!(element instanceof Element)) return false;
    const style = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();

    return (
      element.getAttribute('aria-hidden') !== 'true' &&
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      Number.parseFloat(style.opacity || '1') > 0 &&
      rect.width > 0 &&
      rect.height > 0
    );
  };

  const hasSuccessMessage = (root) => {
    const selectors = 'h1,h2,h3,h4,p,div,span,[role="status"],[aria-live]';
    return Array.from(root.querySelectorAll(selectors)).some((element) => {
      return isVisible(element) &&
        normalizeText(element.textContent).includes(SUCCESS_TEXT);
    });
  };

  const ensureMetaPixel = () => {
    if (typeof window.fbq === 'function') return;

    ((f, b, e, v, n, t, s) => {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  };

  const sendLead = () => {
    if (leadFired) return;
    leadFired = true;

    ensureMetaPixel();

    window.fbq('init', PIXEL_ID);
    window.fbq('trackSingle', PIXEL_ID, 'Lead', {
      content_name: 'Cyber Stärk',
      content_category: 'Shopify Forms',
      form_id: '1176324'
    });

    console.info('[Cyber Stärk] Meta Lead enviado');
  };

  const inspectRoot = (root) => {
    if (!root || watchedRoots.has(root)) return;
    watchedRoots.add(root);

    const check = () => {
      if (!leadFired && hasSuccessMessage(root)) {
        sendLead();
      }

      root.querySelectorAll('*').forEach((element) => {
        if (element.shadowRoot) inspectRoot(element.shadowRoot);
      });
    };

    check();

    const observer = new MutationObserver(check);
    observer.observe(root, {
      subtree: true,
      childList: true,
      attributes: true,
      characterData: true
    });
  };

  const discover = () => {
    const host = document.querySelector('.cyber-stark-form-host');
    if (!host) return;

    inspectRoot(host);

    host.querySelectorAll('*').forEach((element) => {
      if (element.shadowRoot) inspectRoot(element.shadowRoot);
    });
  };

  discover();

  const host = document.querySelector('.cyber-stark-form-host');
  if (host) {
    const hostObserver = new MutationObserver(discover);
    hostObserver.observe(host, { subtree: true, childList: true });
  }

  let attempts = 0;
  const timer = window.setInterval(() => {
    discover();
    attempts += 1;

    if (attempts >= 120 || leadFired) {
      window.clearInterval(timer);
    }
  }, 250);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stark-header"] && !Shopify.designMode) return;
  try {
    
  const menuButton = document.querySelector('.stark-header__menu-button');
  const mobileMenu = document.querySelector('#stark-mobile-menu');
  const menuTransitionDuration = 440;
  let menuCloseTimer;

  const finishClosingMenu = () => {
    if (mobileMenu?.classList.contains('is-open')) return;
    if (mobileMenu) mobileMenu.hidden = true;
  };

  const openMenu = () => {
    if (!mobileMenu || !menuButton) return;
    window.clearTimeout(menuCloseTimer);
    mobileMenu.hidden = false;
    mobileMenu.getBoundingClientRect();
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    menuButton.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('stark-menu-open');
  };

  const closeMenu = () => {
    if (!mobileMenu || !menuButton) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    menuButton.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('stark-menu-open');
    menuCloseTimer = window.setTimeout(finishClosingMenu, menuTransitionDuration);
  };

  menuButton?.addEventListener('click', () => {
    if (!mobileMenu) return;
    if (mobileMenu.classList.contains('is-open')) closeMenu();
    else openMenu();
  });
  document.querySelectorAll('[data-stark-menu-close]').forEach((button) => button.addEventListener('click', closeMenu));
  mobileMenu?.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && mobileMenu?.classList.contains('is-open')) closeMenu();
  });

  document.querySelectorAll('[data-stark-announcements]').forEach((slider) => {
    const slides = [...slider.querySelectorAll('[data-stark-announcement]')];
    if (slides.length < 2) return;
    let index = 0;
    setInterval(() => {
      slides[index].classList.remove('is-active');
      index = (index + 1) % slides.length;
      slides[index].classList.add('is-active');
    }, 4000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stark-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.stark-hero').forEach((hero) => {
    const viewport = hero.querySelector('.stark-hero__viewport');
    const slides = [...hero.querySelectorAll('[data-slide]')];
    const dots = [...hero.querySelectorAll('[data-hero-dot]')];
    if (!viewport || slides.length < 2) return;

    let current = 0;
    let timer;
    let pointerId = null;
    let startX = 0;
    let startY = 0;
    let deltaX = 0;
    let deltaY = 0;
    let swiping = false;
    let suppressClick = false;

    const show = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, position) => slide.classList.toggle('is-active', position === current));
      dots.forEach((dot, position) => dot.classList.toggle('is-active', position === current));
    };

    const restart = () => {
      clearInterval(timer);
      if (hero.dataset.autoplay === 'true') {
        timer = setInterval(() => show(current + 1), Number(hero.dataset.delay || 6000));
      }
    };

    const finishSwipe = () => {
      if (!swiping) return;

      const horizontal = Math.abs(deltaX) > Math.abs(deltaY);
      const threshold = Math.min(90, viewport.clientWidth * 0.16);

      if (horizontal && Math.abs(deltaX) >= threshold) {
        show(current + (deltaX < 0 ? 1 : -1));
        suppressClick = true;
      }

      swiping = false;
      pointerId = null;
      deltaX = 0;
      deltaY = 0;
      restart();
    };

    viewport.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (event.target instanceof Element && event.target.closest('button')) return;

      pointerId = event.pointerId;
      startX = event.clientX;
      startY = event.clientY;
      deltaX = 0;
      deltaY = 0;
      swiping = true;
      suppressClick = false;
      clearInterval(timer);
      viewport.setPointerCapture?.(event.pointerId);
    });

    viewport.addEventListener('pointermove', (event) => {
      if (!swiping || event.pointerId !== pointerId) return;

      deltaX = event.clientX - startX;
      deltaY = event.clientY - startY;

      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 8) {
        event.preventDefault();
      }
    }, { passive: false });

    viewport.addEventListener('pointerup', (event) => {
      if (event.pointerId !== pointerId) return;
      finishSwipe();
    });

    viewport.addEventListener('pointercancel', (event) => {
      if (event.pointerId !== pointerId) return;
      swiping = false;
      pointerId = null;
      restart();
    });

    viewport.addEventListener('click', (event) => {
      const target = event.target;
      if (target instanceof Element && target.closest('button')) return;

      if (suppressClick) {
        event.preventDefault();
        event.stopPropagation();
        suppressClick = false;
        return;
      }

      if (window.Shopify?.designMode) return;

      const link = slides[current]?.querySelector('a[href]');
      if (!link) return;

      event.preventDefault();
      window.location.assign(link.href);
    }, true);

    hero.querySelector('[data-hero-previous]')?.addEventListener('click', () => {
      show(current - 1);
      restart();
    });
    hero.querySelector('[data-hero-next]')?.addEventListener('click', () => {
      show(current + 1);
      restart();
    });
    dots.forEach((dot) => dot.addEventListener('click', () => {
      show(Number(dot.dataset.heroDot));
      restart();
    }));
    restart();
  });

  } catch(e) { console.error(e); }
})();
})();
